import React from 'react';
import SessionStore from 'stores/SessionStore';
import DeclineButton from 'components/v2/buttons/DeclineButton';
import EditButton from 'components/v2/buttons/EditButton';
import ApproveButton from 'components/v2/buttons/ApproveButton';
import HazardButton from 'components/v2/buttons/HazardButton';
import CargomaticTooltip from 'components/v2/Tooltip';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
const isAdmin = SessionStore.getUserType() === 'Admin';
/*
 * An appointment actions table cell component
 */
export default function AppointmentActionsTableCell({ onEditActionClick, onStatusActionClick, appointment, userType, }) {
    const { t } = useTranslation();
    function canDecline() {
        if (userType === 'Admin')
            return true;
        const { status } = appointment;
        return status !== 'declined' && status !== 'missed';
    }
    const renderEditIcon = () => {
        return React.createElement(EditButton, { onClick: () => onEditActionClick(appointment._id) });
    };
    const renderApproveIcon = () => {
        return (isAdmin && (React.createElement(ApproveButton, { onClick: () => onStatusActionClick(appointment._id, 'approved') })));
    };
    const renderHazardIcon = () => {
        return (isAdmin && (React.createElement(HazardButton, { onClick: () => onStatusActionClick(appointment._id, 'missed') })));
    };
    const renderDeclineIcon = () => {
        return (React.createElement(DeclineButton, { disabled: !canDecline, onClick: () => onStatusActionClick(appointment._id, 'declined') }));
    };
    return (React.createElement("div", { className: "flex space-x-2" },
        React.createElement(CargomaticTooltip, { body: renderEditIcon, position: "top" }, titleize(t('EDIT'))),
        React.createElement(CargomaticTooltip, { body: renderApproveIcon, position: "top" }, titleize(t('APPROVE'))),
        React.createElement(CargomaticTooltip, { body: renderHazardIcon, position: "top" }, t('MARK_AS_MISSED')),
        React.createElement(CargomaticTooltip, { body: renderDeclineIcon, position: "top" }, titleize(t('DECLINE')))));
}
